__webpack_require__.p = "https://sweetspot-legacy.web.app/";